import { styled } from '@mui/material';

import { Skeleton } from '../../atoms/Skeleton';
import {
  DOCUMENT_LIST_WIDE_QUERY,
  DOCUMENT_TILE_SIZE,
  DOCUMENT_TILE_SIZE_WIDE,
} from '../DocumentList/documentListContainer';

const Row = styled('li')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: `${DOCUMENT_TILE_SIZE}px minmax(0, 1fr)`,
  columnGap: theme.spacing(1.5),
  alignItems: 'center',
  minHeight: theme.spacing(9),
  paddingBlock: theme.spacing(1.5),
  paddingInline: theme.spacing(2),
  [DOCUMENT_LIST_WIDE_QUERY]: {
    gridTemplateColumns: `${DOCUMENT_TILE_SIZE_WIDE}px minmax(0, 1fr)`,
    columnGap: theme.spacing(2),
    minHeight: theme.spacing(7),
    paddingBlock: theme.spacing(1),
  },
}));

const Tile = styled('span')({
  display: 'flex',
  [DOCUMENT_LIST_WIDE_QUERY]: {
    width: DOCUMENT_TILE_SIZE_WIDE,
    height: DOCUMENT_TILE_SIZE_WIDE,
    overflow: 'hidden',
  },
});

const Lines = styled('span')({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
});

/** Placeholder mirroring a `DocumentListItem` while the library loads. */
export function DocumentListItemSkeleton() {
  return (
    <Row aria-hidden="true">
      <Tile>
        <Skeleton variant="rounded" width={DOCUMENT_TILE_SIZE} height={DOCUMENT_TILE_SIZE} />
      </Tile>
      <Lines>
        <Skeleton variant="text" width="55%" />
        <Skeleton variant="text" width="35%" />
      </Lines>
    </Row>
  );
}
